import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import OktaAuth from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { UserService } from "../shared/services/user.service";
import { AppConfigService } from "../services/app-config.service";

export const roleBasedRedirectGuard: CanActivateFn = (route, state) => {
  const oktaAuth = inject(OKTA_AUTH) as OktaAuth; // Inject OktaAuth
  const userService = inject(UserService);
  const envService = inject(AppConfigService);

  return oktaAuth.getUser().then((user) => {
    user.dnumber = getDnumberFromPreferredUsername(user.preferred_username);
    userService.setUser(user);
    return getUserDetails(user, userService, envService).then((role) => {
      //** user role will be implemented later */
      return true;
    });
  });
};

function getUserDetails(
  user: any,
  userService: UserService,
  envService: AppConfigService,
): Promise<string> {
  return new Promise((resolve, reject) => {
    userService.fetchUserDetails(user.dnumber).subscribe(
      (data) => {
        const role = data?.Advisor ? "Advisor" : "Admin";
        user.role = role;
        userService.setUser(user);
        resolve(role);
      },
      (error) => {
        if (envService.showConsoleLogs) {
          console.error("Error fetching user details:", error);
        }
        reject(error);
      },
    );
  });
}

function getDnumberFromPreferredUsername(preferred_username: string): string {
  if (typeof preferred_username === "string") {
    const [dnumber] = preferred_username.split("@");
    return dnumber ?? "";
  }
  return "";
}
